<template>
  <BreadCrumb PageTitle="Alerts" />
  <AlertsContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import AlertsContent from "../../template-components/UIElements/Alerts/AlertsContent.vue";

export default defineComponent({
  name: "AlertsPage",
  components: {
    BreadCrumb,
    AlertsContent,
  },
});
</script>